import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: ${(props) => props?.color ?? 'none'};
  border-radius: 5px;
  width: fit-content;
  padding: 4px 8px;
  font-weight: 500;
`;

function BgCell(props) {
  const { cell, column } = props;

  const { meta = [], field } = column;

  const allData = cell?.row?.original;

  const data = allData[field.name];

  return (
    <Wrapper color={meta[field.name][data || 0]?.colorCode}>
      {data || (
        <TextStyle variation="subdued">
          <FormattedMessage id="app.noData.message" />
        </TextStyle>
      )}
    </Wrapper>
  );
}

export default BgCell;
